import React, { Component } from 'react';
import { Typography, Grid, TextField, Button } from '@material-ui/core';
import AppContext from '../AppContext';
import Loading from '../components/Loading';
import PaddedGrid from '../components/PaddedGrid';
import APIService from '../services/APIService';
import { withTranslation } from 'react-i18next';

class UserDetails extends Component {
    constructor(props) {
        super(props);

        this.state = { loading: true, user: null };
    }

    save() {
        const params = {
            old_password: this.state.oldpassword,
            password: this.state.password,
            password_confirmation: this.state.password_confirmation
        };

        APIService.updateUser(params)
            .then(() => {
                AppContext.toast(`${this.props.t('Käyttäjätiedot päivitetty')}!`);
            }).catch((error) => {
                console.log(error);
                AppContext.toast(`${this.props.t('Käyttäjätietojen päivitys epäonnistui')} (${error.message})`);
            });
    }

    componentDidMount() {
        AppContext.getUser()
            .then((user) => this.setState({user, loading: false}));
    }

    render() {
        if (this.state.loading) {
            return <Loading/>;
        }

        const { user } = this.state;

        return (
            <PaddedGrid>

                <Grid item xs={12}>
                    <Typography variant="headline">{this.props.t('Käyttäjätiedot')}</Typography>

                    <Typography variant="subheading"><b>{this.props.t('Sähköpostiosoite')}:</b> {user.email}</Typography>

                    <div className="padding-top">
                        <Typography variant="headline" style={{marginTop: "20px"}}>{this.props.t('Vaihda salasana')}</Typography>

                        <TextField
                            label={this.props.t('Nykyinen salasana')}
                            type="password"
                            value={this.state.oldpassword}
                            onChange={(event) => this.setState({oldpassword: event.target.value})}
                            fullWidth
                        />
                        <TextField
                            label={this.props.t('Uusi salasana')}
                            type="password"
                            value={this.state.password}
                            onChange={(event) => this.setState({password: event.target.value})}
                            fullWidth
                        />
                        <TextField
                            label={this.props.t('Vahvista salasana')}
                            type="password"
                            value={this.state.password_confirmation}
                            onChange={(event) => this.setState({password_confirmation: event.target.value})}
                            fullWidth
                        />

                        <Button variant="raised" color="primary" style={{marginTop: "15px"}} onClick={() => this.save()}>{this.props.t('Tallenna')}</Button>
                    </div>
                </Grid>
            </PaddedGrid>
        );
    }
}

export default withTranslation()(UserDetails);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/UserDetails.js